/**
 * Compact "Sources officielles & garanties" block.
 * Inserts 3 contextual external links into the main content of any page so
 * the page itself (not just the footer) signals trusted sources to crawlers
 * and AI engines. All links use rel="external noopener noreferrer".
 *
 * Designed to be discreet: 1 short paragraph with 3 anchors, not a card.
 * Keeps the content/external-link ratio in the 3-15 sweet spot recommended
 * by SEO best practices.
 */
export default function TrustExternalLinks({ className = "" }) {
    return (
        <aside
            className={`mt-12 border-t border-[var(--line)] pt-6 ${className}`}
            aria-label="Sources officielles et garanties"
            data-testid="trust-external-links"
        >
            <p className="text-xs uppercase tracking-[0.18em] text-[var(--ink-soft)]/70 font-bold mb-2">
                <i className="fa-solid fa-shield-halved mr-1.5 text-[var(--amber)]" />
                Sources officielles &amp; garanties
            </p>
            <p className="text-sm text-[var(--ink-soft)] leading-relaxed">
                Vos droits consommateur sont protégés par la{" "}
                <a
                    href="https://www.service-public.fr/particuliers/vosdroits/F11094"
                    target="_blank"
                    rel="noopener noreferrer external"
                    className="text-[var(--navy)] underline decoration-[var(--amber)] decoration-2 underline-offset-2 font-medium"
                >
                    garantie légale de conformité (Service-Public.fr)
                </a>
                . Nos techniciens sont certifiés{" "}
                <a
                    href="https://www.qualirepar.fr/annuaire"
                    target="_blank"
                    rel="noopener noreferrer external"
                    className="text-[var(--navy)] underline decoration-[var(--amber)] decoration-2 underline-offset-2 font-medium"
                >
                    QualiRépar
                </a>
                {" "}et nous appliquons les bonnes pratiques de l&apos;{" "}
                <a
                    href="https://www.ademe.fr/particuliers-eco-citoyens/maison/electromenager-multimedia/"
                    target="_blank"
                    rel="noopener noreferrer external"
                    className="text-[var(--navy)] underline decoration-[var(--amber)] decoration-2 underline-offset-2 font-medium"
                >
                    ADEME pour l&apos;électroménager
                </a>
                .
            </p>
        </aside>
    );
}
